<div class="o-grid o-grid--wrap">
	<div class="o-grid__cell o-grid__cell--w-fixed u-no-p" [ngClass]="{'o-grid__cell--right': vm.user?.id===vm.group.user}">
		<div class="o-grid" [ngClass]="{'o-grid--reverse-h': vm.user?.id!==vm.group.user}">
			<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
				<div class="chat-message-inner-container" style="display: block;"
					 (mouseenter)="vm.onMouseEnter(vm.message)" (mouseleave)="vm.onMouseLeave(vm.message)" #messageQuestionnaireContainer>
					<button class="dots-btn-horizontal"
							*ngIf="!vm.message.deleted && vm.user?.id===vm.message.user.id && (vm.isDesktop ? vm.message.showDots : true)"
							(click)="vm.toggleActions(vm.message, $event, messageQuestionnaireContainer)">
						...
					</button>
				<div class="c-message__bc c-message__bc--fw" *ngIf="!vm.message.deleted" style="margin-top: 4px;">
					<div style="margin-left:5px;" class="o-icon o-icon--doc c-text c-text--main c-text--xxl u-no-mr"></div>
					<div style="margin-left:15px;margin-top:10px;flex:1;text-align:left;">
						<div class="c-text c-text--bold" *ngIf="vm.metadata.questionnaire.codeName !== 'DOM-PRE-BOOKING'">{{ 'ChatQuestionnaire.Description' | translate }}</div>
						<div class="c-text c-text--bold" *ngIf="vm.metadata.questionnaire.codeName == 'DOM-PRE-BOOKING'">{{ 'ChatQuestionnaire.Weight_Loss_Description' | translate }}</div>
						<div id="chatQuestionnaireItemCodeName" class="c-text">{{vm.metadata.questionnaire.codeName}}</div>
						<div style="text-align:right;margin-top: 10px;">
							<a id="chatQuestionnaireItemResultsButton" *ngIf="vm.metadata.userQuestionnaire.token && vm.metadata.status == 'COMPLETED' && (vm.isDoctor || vm.metadata.questionnaire.resultsVisibleToCustomer)" style="margin:5px;cursor:pointer;" (click)="vm.viewResults()">{{ 'ChatQuestionnaire.Results' | translate }}</a>
                            <a id="chatQuestionnaireItemOpenButton" *ngIf="vm.metadata.status == 'INCOMPLETE'" style="margin:5px;cursor:pointer;" (click)="vm.startAnswering()">{{ 'ChatQuestionnaire.Open' | translate }}</a>
						</div>
					</div>
				</div>
					<div class="c-message__bc c-message__bc--fw" *ngIf="vm.message.deleted" style="width: 100px;">
						<p id="chatSimpleTextMessageItem"
						   class="chatSimpleTextMessageItem c-text c-text--wrap"
						   [ngClass]="{'c-message-deleted': vm.message.deleted}"
						   [innerHtml]="vm.message.content">
						</p>
					</div>
					<div class="chat-actions-menu"
						 *ngIf="vm.message.showActions"
						 (click)="$event.stopPropagation()">
						<button (click)="vm.deleteMessage(vm.message)">
							 {{ 'Modal.Title.Delete' | translate }}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="o-grid__cell--w-100" style="padding-top:3px;padding-bottom:5px;" [ngClass]="{'c-message--right': vm.user?.id===vm.message.user.id}" >
        <span class="c-text c-message--footer">{{vm.message.created | date:'HH:mm'}}</span>
        <span *ngIf="vm.user?.id===vm.message.user.id" class="c-text c-text--gray c-text--bold c-message--footer" [ngClass]="{'c-message--seen' : vm.message.id <= vm.lastSeen}">&check;</span>
    </div>
</div>
